// extracted by mini-css-extract-plugin
export default {"r_l":"_9bbaee8c63 d0423e8e57","t":"b308984035"};